function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// 列表页面规范

import { message } from 'antd';
import { getSessionStorage, setSessionStorage } from "../Utils/sessionStorage";
// 获取列表配置
var getPageListConfig = function getPageListConfig(key, init) {
  var _searchData$currentPa5;
  var currentPath = window.location.pathname;
  // 获取搜索条件
  var searchData = getSessionStorage('SEARCH_DATA');
  var searchMethod = {
    // 搜索条件展开/收起
    save_expand: function save_expand() {
      var _searchData$currentPa;
      var value = (searchData === null || searchData === void 0 || (_searchData$currentPa = searchData[currentPath]) === null || _searchData$currentPa === void 0 ? void 0 : _searchData$currentPa[key]) || init || false;
      return Boolean(value);
    },
    // list 数据的某种状态
    save_statusTab: function save_statusTab() {
      var _searchData$currentPa2;
      return (searchData === null || searchData === void 0 || (_searchData$currentPa2 = searchData[currentPath]) === null || _searchData$currentPa2 === void 0 || (_searchData$currentPa2 = _searchData$currentPa2[key]) === null || _searchData$currentPa2 === void 0 ? void 0 : _searchData$currentPa2.toString()) || init || 1;
    },
    // 表单搜索条件
    save_params: function save_params() {
      var _searchData$currentPa3;
      return (searchData === null || searchData === void 0 || (_searchData$currentPa3 = searchData[currentPath]) === null || _searchData$currentPa3 === void 0 ? void 0 : _searchData$currentPa3[key]) || init || {};
    },
    // list tab
    save_listTab: function save_listTab() {
      var _searchData$currentPa4;
      return (searchData === null || searchData === void 0 || (_searchData$currentPa4 = searchData[currentPath]) === null || _searchData$currentPa4 === void 0 ? void 0 : _searchData$currentPa4[key]) || init || 1;
    }
  };
  var searchType = searchMethod[key];
  return searchType ? searchType() : (searchData === null || searchData === void 0 || (_searchData$currentPa5 = searchData[currentPath]) === null || _searchData$currentPa5 === void 0 ? void 0 : _searchData$currentPa5[key]) || {};
};
var setPageListConfig = function setPageListConfig(params, key, clearParams) {
  var _currentUrl$href;
  var currentPath = window.location.pathname;
  var currentMap = new Map();
  currentMap.set(currentPath, params);
  var searchData = getSessionStorage('SEARCH_DATA') || {};

  // 更新搜索条件
  searchData[currentPath] = _objectSpread(_objectSpread({}, searchData[currentPath]), {}, _defineProperty({}, key, currentMap.get(currentPath)));
  if (clearParams) {
    var _searchData$currentPa6;
    searchData[currentPath] = _objectSpread(_objectSpread({}, searchData[currentPath]), {}, {
      save_params: {},
      // 清空表单搜索条件
      save_statusTab: false,
      // 清空列表的status
      save_expand: false // 默认收起
    });

    var listTabValue = ((_searchData$currentPa6 = searchData[currentPath]) === null || _searchData$currentPa6 === void 0 ? void 0 : _searchData$currentPa6.save_listTab) || '1';
    /**  save_listTab的切换  需要清空url的search  */
    clearUrlParams(listTabValue, 'save_listTab');
  }

  // 更新session
  setSessionStorage('SEARCH_DATA', searchData);
  var currentData = searchData[currentPath];
  var newDataParams = {};

  // 如果value是对象，取出对象中的每一个值
  for (var ley in currentData) {
    if (currentData[key] && _typeof(currentData[key]) === 'object') {
      newDataParams = _objectSpread(_objectSpread({}, newDataParams), currentData[key]);
    } else {
      newDataParams[key] = currentData[key];
    }
  }

  // 将params存储到url上
  var currentUrl = new URL(window.location.href);
  for (var _key in newDataParams) {
    if (currentUrl.searchParams.has(_key)) {
      currentUrl.searchParams.delete(_key);
    }
    var value = newDataParams[_key];
    if (value !== undefined && value !== null) {
      var tempValue = void 0;
      if (typeof value === 'string') {
        tempValue = encodeURIComponent(value);
      } else {
        tempValue = encodeURIComponent(JSON.stringify(value));
      }
      currentUrl.searchParams.append(_key, tempValue);
    }
  }
  if ((currentUrl === null || currentUrl === void 0 || (_currentUrl$href = currentUrl.href) === null || _currentUrl$href === void 0 ? void 0 : _currentUrl$href.length) > 65536) {
    message.error('地址长度不能超过65536,请重置');
    window.sessionStorage.removeItem('searchData');
    return;
  }
  window.history.replaceState({}, '', currentUrl);
};
export var clearUrlParams = function clearUrlParams(i, key) {
  var currentUrl = new URL(window.location.href);
  currentUrl.search = '';
  if (i && key) {
    currentUrl.searchParams.append(key, i);
  }
  window.history.replaceState({}, '', currentUrl);
};
var usePageListConfig = function usePageListConfig() {
  return {
    getPageListConfig: getPageListConfig,
    setPageListConfig: setPageListConfig
  };
};
export default usePageListConfig;